import { render } from "./FormScreen.vue?vue&type=template&id=18b07f3e&scoped=true"
import script from "./FormScreen.vue?vue&type=script&lang=js"
export * from "./FormScreen.vue?vue&type=script&lang=js"

import "./FormScreen.vue?vue&type=style&index=0&id=18b07f3e&scoped=true&lang=css"

import exportComponent from "/builds/cloud/messenger/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b07f3e"]])

export default __exports__